import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { StyledChatBotScreen, StyledChatAndHistoryContainer } from './styled'
import ChatConversationSection from './ChatConversationSection'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery, Drawer } from '@mui/material'
import { getIsIframe } from '../../utils/getIsIframe'
import getForcedMobile from '../../utils/forceMobile'
import { useAppSelector, useAppDispatch } from '../../reducers/hooks'
import { userReducer } from '../../reducers/user/userReducer'
import ChatHistoryLayout from '../ChatHistory'

const ChatBotScreen: React.FC = (): JSX.Element => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const forcedMobile = getForcedMobile()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isIframe = getIsIframe()
  const sessionId = useAppSelector((state) => state.user.sessionId)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const hasTouchCapability = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  const handleStartNewChat = (): void => {
    dispatch(userReducer.actions.changeSessionId(`${uuidv4()}`))
  }

  const handleDrawerToggle = (): void => {
    setDrawerOpen(!drawerOpen)
  }

  const handleDrawerClose = (): void => {
    setDrawerOpen(false)
  }

  return (
    <StyledChatBotScreen isMobile={isMobile || forcedMobile} isIframe={isIframe}>
      <StyledChatAndHistoryContainer>
        {!(isMobile || forcedMobile) && !hasTouchCapability && <ChatHistoryLayout/>}
        <ChatConversationSection
          session={sessionId}
          onOpenNewChat={handleStartNewChat}
          onMenuClick={(hasTouchCapability || forcedMobile) ? handleDrawerToggle : undefined}
        />
        {(hasTouchCapability || forcedMobile) && (
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={handleDrawerClose}
            sx={{
              '& .MuiDrawer-paper': {
                width: '100%',
                boxSizing: 'border-box'
              }
            }}
          >
            <ChatHistoryLayout inDrawer={true} onSessionSelect={handleDrawerClose} onClose={handleDrawerClose} />
          </Drawer>
        )}
      </StyledChatAndHistoryContainer>
    </StyledChatBotScreen>
  )
}

export default ChatBotScreen
